import React, { useEffect } from 'react';
import './projectoverview.css';
import Architecture from '../../../assets/architecture.jpg';
import OilPlatform from '../../../assets/3.jpg';
import img10 from '../../../assets/img10.jpg';
import arch from '../../../assets/arch.jpg';
import img4 from '../../../assets/img4.jpg';
import packages from '../../../assets/packages.jpg';
import Too from '../../../assets/Too.jpg';
import Tooo from '../../../assets/img5.jpg';
import Toooo from '../../../assets/img3.jpg';

// Import AOS if you're using it for animations
import AOS from 'aos';
import 'aos/dist/aos.css';

const ProjectOverview = () => {
    useEffect(() => {
        // Initialize AOS animation library
        AOS.init({
            duration: 800,
            once: false,
        });
    }, []);

    return (
        <div className='project-overview'>
            <div className='header'>
                <h2 data-aos="fade-up" data-aos-duration="300">Our Perks</h2>
                <div data-aos="fade-up" data-aos-duration="400" className="block"></div>
            </div>

            {/* First section - Card Style */}
            <section className="feature-cards">
                <div className="feature-card" data-aos="fade-up" data-aos-duration="400">
                    <div className="card-image">
                        <img src={packages} alt="Oil industry workers" />
                    </div>
                    <div className="card-content">
                        <h3>Powering the Lives of Millions</h3>
                        <p>Our Company's refining activities have been focused on meeting the market demand for quality petroleum products.</p>
                        <p className="highlight-text">Backed by Decades of Excellence</p>
                    </div>
                </div>
                
                <div className="feature-card" data-aos="fade-up" data-aos-duration="500">
                    <div className="card-image">
                        <img src={img4} alt="Oil refinery architecture" />
                    </div>
                    <div className="card-content">
                        <h3>Ambition</h3>
                        <p>Our ambition is to be the world's most carbon-efficient oil and gas producer, as well as driving innovation in offshore wind and renewable.</p>
                        <div className="cta-button">
                            <button>Learn More</button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Second section - Full Width Banner */}
            <section className="banner-section" data-aos="fade-up" data-aos-duration="600">
                <div className="banner-overlay"></div>
                <div className="banner-content">
                    <h3>Oil Refining Excellence</h3>
                    <p> Helix Energy Solutions excels in high-volume oil refining, focusing on meeting market demand for quality petroleum products. Over the years, the company has consistently modernized its refineries, enhancing product quality and competitiveness.</p>
                    
                </div>
            </section>

            {/* Third section - Side-by-side with gradient */}
            <section className="gradient-section">
                <div className="gradient-overlay"></div>
                <div className="gradient-content" data-aos="fade-right" data-aos-duration="500">
                    <div className="content-wrapper">
                        <h3>Safety Management</h3>
                        <p>Traditionally, most of  Helix Energy Solutions's gas has been sold through long-term contracts to large European gas companies and suppliers. In the absence of a separate market price for gas, the sale price has often been indexed to the price of oil.</p>
                        <ul className="safety-list">
                            <li>Enhanced safety protocols</li>
                            <li>Continuous employee training</li>
                            <li>State-of-the-art equipment</li>
                        </ul>
                    </div>
                </div>
                <div className="gradient-image" data-aos="fade-left" data-aos-duration="600">
                    <img src={img10} alt="Safety management" />
                </div>
            </section>

            {/* Fourth section - Modern split */}
            <section className="modern-split">
                <div className="split-text" data-aos="fade-up" data-aos-duration="500">
                    <span className="eyebrow">Built To Last</span>
                    <h3>Pioneering Opportunities in New Energy</h3>
                    <p>Gulfstream Energy Solutions: Creating sustainable future through innovation and forward-thinking leadership.</p>
                    <div className="feature-points">
                        <div className="feature-point">
                            <span className="point-icon">⚡</span>
                            <span className="point-text">Embracing Opportunities</span>
                        </div>
                        <div className="feature-point">
                            <span className="point-icon">🌱</span>
                            <span className="point-text">Sustainable Growth</span>
                        </div>
                        <div className="feature-point">
                            <span className="point-icon">🔄</span>
                            <span className="point-text">Continuous Innovation</span>
                        </div>
                    </div>
                </div>
                <div className="split-image" data-aos="fade-up" data-aos-duration="600">
                    <div className="image-container">
                        <img src={arch} alt="Energy innovation" />
                        <div className="image-overlay">
                            <span>Innovation</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Hero section that matches Image 1 from your screenshot */}
            <section className="sustainability-hero">
                <div className="sustainability-content">
                    <h2 data-aos="fade-up" data-aos-duration="400">
                        Can an oil and gas company be part of a sustainable energy future?
                    </h2>
                    <p data-aos="fade-up" data-aos-duration="500">
                        We're working actively to reduce the climate emissions, put a price on carbon and benefit societies around the world. We aim to be world's most carbon-efficient oil and gas producer, and are investing actively in renewable.
                    </p>
                </div>
                <div data-aos="fade-left" data-aos-duration="700" className="sustainability-image">
                    <img src={Too} alt="Worker in safety gear" />
                </div>
            </section>

            {/* Services section that matches Image 2 from your screenshot */}
            

            {/* Sustainability section that matches Image 3 from your screenshot */}
            <section className="sustainability-section">
                <div className="sustainability-image-large" data-aos="fade-right" data-aos-duration="700">
                    <img src={OilPlatform} alt="Offshore oil platform" />
                </div>
                <div className="sustainability-info">
                    <div className="sustainability-header">
                        <span className="line"></span>
                        <h2>SUSTAINABILITY</h2>
                    </div>
                    <div className="sustainability-points">
                        <div className="point" data-aos="fade-up" data-aos-duration="400">
                            <span className="dot"></span>
                            <p>
                                Can an oil and gas company be part of a sustainable energy future? We are working actively to reduce climate emissions, put a price on carbon, and benefit societies around the world. We are determined to develop resources responsibly and create lasting value for communities. Our industry needs to be part of the solution. We aim to be recognized as the most carbon-efficient oil and gas producer, committed to creating lasting value for communities.
                            </p>
                        </div>
                        <div className="point" data-aos="fade-up" data-aos-duration="500">
                            <span className="dot"></span>
                            <p>
                                In all our business activities we comply with applicable laws, act in an ethical, sustainable and socially responsible manner, practise good corporate governance and respect internationally recognised human rights. We maintain an open dialogue on ethical issues — both internally and externally. Open, honest and accurate communication is essential to our integrity and business success.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Lower sections with updated designs */}
            <section className="section-overview">
                <div className="section-text">
                    <h3 data-aos="fade-up" data-aos-duration="400">Commitment to a Low-Carbon Future</h3>
                    <p data-aos="fade-up" data-aos-duration="400">
                        Understanding the necessity of a low-carbon future,  Helix Energy Solutions is dedicated to pioneering sustainable solutions. Our focus is on reducing carbon emissions and promoting cleaner energy practices for a better tomorrow.
                    </p>
                    <p data-aos="fade-up" data-aos-duration="400">
                        At  Helix Energy Solutions, we believe in transforming challenges into opportunities. We continuously seek new ways to leverage our expertise in the energy industry, exploring advancements in new energy sources while driving innovation in oil and gas globally.
                    </p>
                </div>
                <div data-aos="fade-up" data-aos-duration="700" className='project-image'>
                    <img src={Architecture} alt="Low-carbon solutions" />
                </div>
            </section>

            <section className="section-overview">
                <div className="section-text">
                    <h3 data-aos="fade-up" data-aos-duration="400">Prioritizing Safety and Well-being</h3>
                    <p data-aos="fade-up" data-aos-duration="400">
                         Helix Energy Solutions is unwavering in its commitment to ensuring the safety and well-being of our employees, contractors, and communities. Our "Zero Harm Everyday" philosophy underscores our dedication to creating a workplace where everyone can perform their duties without the risk of injury or harm.
                    </p>
                    <p data-aos="fade-up" data-aos-duration="400">
                        Comprehensive Safety Protocols
                    </p>
                    <p data-aos="fade-up" data-aos-duration="400">
                        We implement rigorous safety protocols and continuous training programs to maintain the highest safety standards. Our proactive approach includes regular assessments, safety drills, and adopting best practices to mitigate potential hazards in all our operations.
                    </p>
                </div>
                <div data-aos="fade-up" data-aos-duration="400" className='project-image'>
                    <img src={Tooo} alt="Safety protocols" />
                </div>
            </section>

            <section className="section-overview">
                <div data-aos="fade-up" data-aos-duration="400" className='project-image'>
                    <img src={Toooo} alt="Safety culture" />
                </div>
                <div className="section-text">
                    <h3 data-aos="fade-up" data-aos-duration="400">Culture of Accountability and Continuous Improvement</h3>
                    <p data-aos="fade-up" data-aos-duration="400">
                        At  Helix Energy Solutions, fostering a culture of accountability and continuous improvement is essential. We encourage our team members to take personal responsibility for safety and actively seek feedback to enhance our practices. This commitment ensures that safety remains a core value in everything we do, striving for zero incidents every day.
                    </p>
                </div>
            </section>
        </div>
    );
};

export default ProjectOverview;